"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLpg32 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h32v32H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M11.5 9.405v-3.5h9v3.5m0 15v2.5h-9v-2.5m0-15h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3Zm4.5 0v-1.75m-2.5 0h5m.187 10.727a2.767 2.767 0 0 1-2.643 2.271c-1.234.049-2.33-.674-2.672-1.748-.292-.918-.062-1.927.702-3.082.1-.152.325-.43.525-.67.009.043.019.085.03.124.086.297.2.584.437.678.145.059.374.062.631-.254.558-.686.817-1.61.716-2.546 1.735 1.588 2.584 3.537 2.274 5.227Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgLpg32;
